export const RECENT_TRANSACTION_ID = 'recentTransactionId';
